import { Profile } from './profile';

export interface Activity {
  id: string;
  title: string;
  date: Date | null;
  description: string;
  category: string;
  city: string;
  venue: string;
  hostUsername: string;
  isCancelled: boolean;
  isGoing: boolean;
  isHost: boolean;
  host?: Profile;
  attendees: Profile[];
}

export class Activity implements Activity {
  constructor(init?: ActivityFormValues) {
    //  shorthand way of assigning the values of init to the properties of the class
    Object.assign(this, init);
  }
}

export class ActivityFormValues {
  id?: string = undefined;
  title = '';
  category = '';
  description = '';
  date: Date | null = null;
  city = '';
  venue = '';

  constructor(activity?: ActivityFormValues) {
    if (activity) {
      this.id = activity.id;
      this.title = activity.title;
      this.category = activity.category;
      this.description = activity.description;
      this.date = activity.date;
      this.city = activity.city;
      this.venue = activity.venue;

      // the shorthand: Object.assign(this, activity); does to the same thing as the above
    }
  }
}
